'use strict';

const SV = require('server-vars');
const deviceTypes = require('../constants/deviceTypes');

/**
 * Checks device type.
 * Device types are defined in global/costants/deviceTypes.es.js
 *
 * @return {boolean}
 */
const deviceTypeHelper = {
    isMobile() {
        return SV.get('settings.deviceType') === deviceTypes.MOBILE;
    },

    isTablet() {
        return SV.get('settings.deviceType') === deviceTypes.TABLET;
    },

    isDesktop() {
        return SV.get('settings.deviceType') === deviceTypes.DESKTOP;
    },

    isMobileOrTablet() {
        return this.isMobile() || this.isTablet();
    },
};

module.exports = deviceTypeHelper;



// WEBPACK FOOTER //
// ./assets/js/global/utils/deviceTypeHelper.es.js